import { Store } from "./index";
import Action from "./models/action";
import { Part } from "../../components/parts/PartsList";
import { FullImage } from "../../components/configuration/ConfigurationView";
import { Price } from "../../components/main/motorcycles/MotorcycleView";
import { getCategoryInformation } from "./vehicleOverview";
import { initialReduxState as emptyState } from "./index";
import { SaveDetailsData } from "../../components/dialogs/saveConfiguration";

export interface LoadConfigurationResponse {
	Vehicle: Vehicle;
	Configuration: Configuration;
}

interface Configuration {
	ClonedConfigurationId: number;
	SaveDetails: SaveDetailsData;
	SelectedPartIds: string[];
	TotalPrice: Price;
}

interface Vehicle {
	ModelId: string;
	Name: string;
	AvailableParts: Part[];
	FullImages: FullImage[];
}

export default function LoadReducer(
	state: Store,
	action: Action<LoadConfigurationResponse>
): Store {
	const {
		Vehicle: { AvailableParts: Parts, FullImages, Name, ModelId },
		Configuration: {
			ClonedConfigurationId,
			TotalPrice: price,
			SelectedPartIds
		},
		heroImgUrl
	} = action.payload as LoadConfigurationResponse & { heroImgUrl: string };

	const { culture, market, companyId } = state.configurationState;

	return {
		...emptyState,
		parts: {
			...emptyState.parts,
			applied: getAppliedParts(Parts, SelectedPartIds)
		},
		vehicleOverviewState: {
			...emptyState.vehicleOverviewState,
			Parts,
			Categories: getCategoryInformation(Parts),
			Vehicle: {
				...state.vehicleOverviewState.Vehicle,
				Name,
				ModelId,
				Hero: {
					...state.vehicleOverviewState.Vehicle.Hero,
					ImageUrl: heroImgUrl
				}
			}
		},
		configurationState: {
			...emptyState.configurationState,
			configuration: {
				ConfigurationId: ClonedConfigurationId,
				FullImages
			},
			price,
			culture,
			market,
			companyId,
			wasRecentlyCreated: false
		},
		views: {
			...emptyState.views,
			// this will take user to the summary
			showConfigurationSummary: true
		}
	};
}

function getAppliedParts(Parts: Part[], PartIds: string[]) {
	return Parts.filter((part: Part) => PartIds.includes(part.PartId));
}
